import type { NodeId } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ToggleSelectNodeCommand {
  nodeId: NodeId;
  /** If specified, selection is set to desired state. If not, selection is "toggled". */
  select?: boolean;
}

export const toggleSelectNode: GraphCommandFactory<ToggleSelectNodeCommand> =
  (cmdContext) =>
  ({ nodeId, select }) => {
    cmdContext.updateState((draft) => {
      const { selectedNodeIds } = draft.graph;
      if (select ?? !draft.graph.selectedNodeIds.has(nodeId)) {
        selectedNodeIds.add(nodeId);
      } else {
        selectedNodeIds.delete(nodeId);
      }
    });
  };
